export default __webpack_public_path__ + "static/media/icon_inclinic.c20ae85b.svg";